<script lang="ts">
    import type {Auth} from 'src/typings';
    import {setLoginSystemsContext} from 'shared/login/kp-login/context';
    import type {AuthenticationSystemView, LoginView} from 'shared/login/kp-login/types';

    export let loginView: LoginView;
    export let authSystemView: AuthenticationSystemView;
    export let onLoginSuccess: (auth: Auth) => void;
    export let onLoginCancel: () => void;

    setLoginSystemsContext({loginView, authSystemView, onLoginSuccess, onLoginCancel});
</script>

<slot/>